import { useTranslation } from "react-i18next";
import { Box, HStack, VStack, Text } from "@chakra-ui/react";

// import { CreateAsset } from 'graphql/queries/types/CreateAsset';
// import { UpdateAsset } from 'graphql/queries/types/UpdateAsset';
import { ApolloError } from "@apollo/client";
import {
  CreateAssetMutation,
  UpdateAssetMutation,
  AssetInput,
} from "graphql/queries/generated/queries";

import { FieldGroup, FormInputHook } from "components/ui";
import { BaseSyntheticEvent } from "react";

import ASSET_COSTANTS from "constants/asset";

import {
  UseFormRegister,
  UseFormGetValues,
  UseFormSetError,
  UseFormSetValue,
} from "react-hook-form";

interface SettingNewCategoryFormProps {
  onSubmit: (e?: BaseSyntheticEvent<object, any, any>) => Promise<void>;
  register: UseFormRegister<AssetInput>;
  getValues: UseFormGetValues<AssetInput>;
  watch: any; // UseFormWatch<AssetInput>,
  setValue: UseFormSetValue<AssetInput>;
  setError: UseFormSetError<AssetInput>;
  category: string;
  children?: React.ReactNode;
  createAssetData: CreateAssetMutation | null | undefined;
  updateAssetData: UpdateAssetMutation | null | undefined;
  createAssetError: ApolloError | undefined;
  updateAssetError: ApolloError | undefined;
  createAssetLoading: boolean | undefined;
  updateAssetLoading: boolean | undefined;
}

const VOID_OPTION = [{ label: "-- Select --", value: "" }];

const SettingNewCategoryForm = ({
  // eslint-disable-next-line react/prop-types
  onSubmit,
  // handleChange,
  // handleRadioButtons,
  // values,
  register,
  setValue,
  setError,
  getValues,
  watch,
  createAssetData,
  updateAssetData,
  createAssetError,
  updateAssetError,
  createAssetLoading,
  updateAssetLoading,
  category,
  children,
}: SettingNewCategoryFormProps) => {
  const { t } = useTranslation();
  const { title } = getValues();


  return (
    <>
      {/* <Box p={6} maxW="6xl">
        <Stack spacing="4" divider={<StackDivider />}> */}
          <Box alignItems="flex-start">
            <Text textAlign="left">Categoria {category}</Text>
          </Box>

          <FieldGroup title={t("Barriers and handling")} subtitle={t("Lorem ipsum dolor sit amet")} py={8}>
            <VStack width="full" align="left">
              <HStack>
                <FormInputHook label="Barriers / Protections" type="checkbox" name="hasBarriers" />

                <FormInputHook label="" placeholder="Notes" name="barriersDetails" />
              </HStack>

              <HStack>
                <FormInputHook label="Handling requirements" name="handlingRequirements" />
              </HStack>
            </VStack>
          </FieldGroup>



          <FieldGroup title={t("Injury risk")} subtitle={t("Lorem ipsum dolor sit amet")} py={8}>
            <VStack width="full" align="left">
              <HStack alignItems="flex-end">
                <FormInputHook
                  label=""
                  options={VOID_OPTION.concat(ASSET_COSTANTS.INJURY_RISK)}
                  name="injuryRisk"
                />
                <FormInputHook label="" name="injuryRiskDescription" placeholder="Description" />
              </HStack>
            </VStack>
          </FieldGroup>


          <FieldGroup title={t("Setting details")} subtitle={t("Lorem ipsum dolor sit amet")} py={8}>
            <VStack width="full" align="left">
              <HStack alignItems="flex-end">
                <FormInputHook label="Moulding support base" name="mouldingSupportBase" />
              </HStack>

              <HStack alignItems="flex-end">
                <FormInputHook label="Hardware tools / installation" name="hardwareToolsInstallation" />
              </HStack>

              <HStack alignItems="flex-end">
                <FormInputHook label="Conservation" name="conservation" />
              </HStack>

              <HStack alignItems="flex-end">
                <FormInputHook label="Lender requests" name="lenderRequests" />
              </HStack>
            </VStack>
          </FieldGroup>




          <FieldGroup title={t("Notes")} subtitle={t("Lorem ipsum dolor sit amet")} py={8}>
            <VStack width="full" align="left">
              <HStack>
                <FormInputHook
                  label=""
                  name="settingNotes"
                  type="textarea"
                />
              </HStack>
            </VStack>
          </FieldGroup>



          {/* <Button
            isLoading={createAssetLoading || updateAssetLoading}
            loadingText="Loading"
            type="submit"
          >
            {t("Save")}
          </Button>
          {children} */}
        {/* </Stack>
      </Box> */}
      {/* <ButtonGroup pb={6} pl={6} display="block" textAlign="left" variant="outline">
        <Button
            isLoading={createAssetLoading || updateAssetLoading}
            loadingText="Loading"
            type="submit"
            variant="primary"
          >
            {t("Update")}
        </Button>
        {children}
      </ButtonGroup> */}
    </>
  );
};

export default SettingNewCategoryForm;
